import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Row,
  Col,
  Image,
  Button,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Tabs,
  Tab,
  Modal,
} from "react-bootstrap";
import fileSaver from "file-saver";
import {
  SliderPanel,
  CsplTable as Table,
  PayrollPendingSubmission,
  FormControlSearch,
  LoaderWrapper,
  Link,
} from "../../../components";
import { MANAGE_PAYROLL_ROUTES } from "../../../utils/constants/payroll";
import pendingSubmissionMaster from "../../../mocks/pendingSubmissionMaster.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimes,
  faDownload,
} from "@fortawesome/pro-light-svg-icons";
import { camelCase, get, isEmpty, toLower } from "lodash";
import {
  acceptEmployeeWarnings,
  getAllRecords,
  getWarningsInECR,
  downloadpreviewfile,
} from "../../../services";
import {
  EMPLOYEE_RECORDS_TO_FETCH,
  ssnMasking,
  usDateFormat,
  usCurrency,
  ROUTES,
} from "../../../utils";
import upload from "../../../styles/upload.png";
import sftp from "../../../styles/ftp.png";
import create from "../../../styles/create.png";
import AddToolTip from "../../../components/AddToolTip";
import {
  getTempEmployeeDetailsforPayroll,
  finalSubmit,
} from "../../../services";
import { useHistory } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import { useDeepEffect } from "../../../abstracts";
import authService from "../../../components/api-authorization/AuthorizeService";
import permissions from "../../../mocks/menuPermissions.json";
import moment from "moment";
const columns = [
  // {
  //   label: "Social Security Number",
  //   className: "column-snn col-md-3",
  //   columnName: "ssn",
  // },
  {
    label: "Plan name",
    className: "width-30",
    columnName: "employeeName",
  },
  {
    label: "Plan ID",
    className: "width-30 pad-left-10",
    columnName: "planId",
  },
  {
    label: "Pay date",
    className: "width-30",
    columnName: "payDate ",
  },
  {
    label: "Total records",
    className: "width-30 pad-right-53",
    columnName: "",
  },
];

const employeeColumns = [
  {
    label: "Employee Details",
    className: "width-40",
    columnName: "employeeName",
  },
  {
    label: "Plan ID",
    className: "width-40",
    columnName: "planId ",
  },
  {
    label: "Pay date",
    className: "width-20",
    columnName: "payDate",
  },
];

const previewfile = (fileUploadId, planId) => {
  var extension =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  downloadpreviewfile(fileUploadId)
    .then((response) => {
      var blob = new Blob([response], {
        type: extension,
      });
      fileSaver.saveAs(
        blob,
        `PreviewFile_${planId}_${usDateFormat(new Date())}.xlsx`
      );
    })
    .catch((error) => {});
};
const PayrollSubmission = (props) => {
  const {
    fileId,
    data,
    setIsLoading,
    totalFunding,
    tabChange,
    enableSubmit,
    setPayrollSubmit,
    isRecordDeleted,
    menu,
    subMenu,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedTabIndex, setTabIndex] = useState("payroll_details");
  const [isModalOpenAll, setModalOpenAll] = useState(false);
  const [loadForPayrollFunding, setIsLoad] = useState(false);
  const [submissionReport, setSubmissionReport] = useState([]);
  const history = useHistory();
  const [selectedList, setSelectedList] = useState({
    payrollFile: [],
  });
  const [filteredValues, setFilteredValues] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [errorsDetectedAndResolved, setErrorsDetectedAndResolved] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [deletedEmployeesCount, setDeletedEmployeesCount] = useState(0);
  const enableView = useRef(true);
  const [searchValue, setSearchValue] = useState("");
  const [request, setRequest] = useState({
    fileId: fileId,
    from: 0,
    offset: EMPLOYEE_RECORDS_TO_FETCH,
    searchInput: "",
  });
  const [request1, setRequest1] = useState({
    fileId: fileId,
    from: 0,
    offset: EMPLOYEE_RECORDS_TO_FETCH,
  });
  //setSubmissionReport(response);
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  // useEffect(() => {
  // getAllRecords(request1).then((response) => {
  //   setSubmissionReport(response.errorReportDetails);
  //   setErrorsDetectedAndResolved(response.errorsDetectedAndResolved);
  //   setTotalRecords(response.totalRecords);
  //   setDeletedEmployeesCount(response.deletedEmployeesCount);
  // });
  // }, [request1]);
  useDeepEffect(() => {
    setIsLoading(true);
    getAllRecords(request)
      .then((response) => {
        if (response?.errorReportDetails.length < EMPLOYEE_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);
        if (append)
          setFilteredValues((filteredValues) => {
            return [...filteredValues, ...response?.errorReportDetails];
          });
        else {
          setFilteredValues(response?.errorReportDetails);
        }
        setErrorsDetectedAndResolved(response.errorsDetectedAndResolved);
        setTotalRecords(response.totalRecords);
        setDeletedEmployeesCount(response.deletedEmployeesCount);
        setIsLoading(false);
      })

      .catch((error) => {
        //Handle Errors
        setIsLoading(false);
      });
  }, [request, isRecordDeleted]);
  const finalSubmitClick = () => {
    setIsLoad(true);
    finalSubmit(fileId, data.fileType)
      .then((response) => {
        if (response) {
          if (data.fileType === 1) {
            history.push(`${MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING}`);
          } else {
            setPayrollSubmit(true);
            setIsLoad(false);
            tabChange(4);
            history.push(`${ROUTES.PAYROLL_FILE_STATUS}/${fileId}/?tab=4`);
          }
        }
      })
      .catch((error) => {
        setIsLoad(false);
      });
  };
  const showPopup = (id) => {
    setSelectedList(id);
    setModalOpen(true);
  };
  const showPopupAll = () => {
    setModalOpenAll(true);
  };
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [notification, setNotification] = useState([]);

  const handleClose = () => {
    setIsWarningModalOpen(false);
  };
  useEffect(() => {
    setIsLoading(true);
    getWarningsInECR(request).then((response) => {
      setIsLoading(false);
      //setWarnings(response.filter((x) => x.referenceId !== 0).map((x) => x));
      var not = response.filter((x) => x.referenceId === 0);
      setNotification(not);
      if (not.length > 0) setIsWarningModalOpen(true);
    });
  }, []);
  const AcceptNotificationClick = () => {
    //values.acceptWarning = true;
    setIsWarningModalOpen(false);
    acceptEmployeeWarnings({
      acceptedWarningIds: notification.map((x) => x.lookUpId[0]),
      fileUploadId: fileId,
    });
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  useDeepEffect(() => {
    if (data.fileType != 1) return;
    enableView.current = false;
  }, [data.fileType]);

  useDeepEffect(() => {
    if (searchValue === "")
      setRequest({ ...request, from: 0, searchInput: "" });
  }, [searchValue]);
  const getFileExtension = () => {
    let ext = data.fileName.slice(
      get(data, "fileName").indexOf("."),
      get(data, "fileName")?.length
    );
    switch (ext) {
      case 1:
        ext = "csv";
        break;
      case 2:
        ext = "xlsx";
        break;
      default:
        break;
    }
    return ext;
  };
  const formattedPayDate = usDateFormat(data.payDate);

  return (
    <LoaderWrapper isLoading={loadForPayrollFunding}>
      <div className="pending-submission" id={fileId}>
        <div className="border-top" />
        <Row className="justify-content-space-between">
          <Col md="12" className="mt-07">
            <div className="submission-header-wrapper ">
              <div className="background-grey h-auto">
                <div className="d-flex justify-content-space-between mr-08">
                  {get(data, "fileName") &&
                  get(data, "fileName").length >= 30 ? (
                    <div>
                      <p className="mt-20 text-black ft-14 font-weight-500 ml-08">
                        <Image
                          src={
                            get(data, "uploadedThrough") == "FileUpload"
                              ? upload
                              : get(data, "uploadedThrough") == "CreatePayroll"
                              ? create
                              : sftp
                          }
                          className="mr-3"
                          style={{
                            width:
                              get(data, "uploadedThrough") == "Finch" && "30px",
                          }}
                        />
                        <OverlayTrigger
                          overlay={<Tooltip>{get(data, "fileName")}</Tooltip>}
                        >
                          <span>
                            {(get(data, "fileName") || "").slice(0, 30)}...{" "}
                            {getFileExtension()}
                          </span>
                        </OverlayTrigger>
                      </p>
                    </div>
                  ) : (
                    <div>
                      <p className="mt-20 text-black ft-14 font-weight-500">
                        <Image
                          src={
                            get(data, "uploadedThrough") == "FileUpload"
                              ? upload
                              : sftp
                          }
                          className="mr-3"
                          style={{
                            width:
                              get(data, "uploadedThrough") == "Finch" && "25px",
                          }}
                        />
                        <span>{get(data, "fileName")}</span>
                      </p>
                    </div>
                  )}
                  {data.fileType != 1 && (
                    <span>
                      <h4 className="total-text">Total Funding</h4>
                      <h1 className="total-amount">
                        {usCurrency(data.totalAmount)}
                      </h1>
                    </span>
                  )}
                </div>
                <div
                  className={`d-flex justify-content-space-between pending-payroll-wrapper file-sub-card ${
                    data.fileType === 2 || data.fileType === 3 ? "bbNone" : ""
                  }`}
                >
                  <div
                    style={{ width: "20%" }}
                    className="d-flex flex-column justify-content-space-between"
                  >
                    <p className="grey-text ft-12">
                      Employees <br /> in the file
                    </p>
                    <div className="black-text ft-18">{totalRecords}</div>
                  </div>
                  <div
                    style={{ width: "20%" }}
                    className="d-flex flex-column justify-content-space-between"
                  >
                    <p className="grey-text ft-12">
                      Total <br /> Hours
                    </p>
                    <div className="black-text ft-18">
                      {(data.totalHours ?? 0).toFixed(2)}
                    </div>
                  </div>
                  <div
                    style={{ width: "20%" }}
                    className="d-flex flex-column justify-content-space-between"
                  >
                    <p className="grey-text ft-12">
                      Employees <br /> accessible to you
                    </p>
                    <div className="black-text ft-18">{totalRecords}</div>
                  </div>
                  <div
                    style={{ width: "20%" }}
                    className="d-flex flex-column justify-content-space-between"
                  >
                    <p className="grey-text ft-12">
                      Errors and warnings detected
                      <br />
                      and resolved
                    </p>
                    <div className="black-text ft-18">
                      {errorsDetectedAndResolved}
                    </div>
                  </div>
                  <div
                    style={{ width: "15%" }}
                    className="d-flex flex-column justify-content-space-between"
                  >
                    <p className="grey-text ft-12">
                      Employees
                      <br /> deleted
                    </p>
                    <div className="black-text ft-18">
                      {deletedEmployeesCount}
                    </div>
                  </div>
                </div>
                {/* <div
                  style={{ width: "20%" }}
                  className="d-flex flex-column justify-content-space-between"
                >
                  <p className="grey-text ft-12">
                    Forfeiture monies to offset funding
                  </p>
                  <div>Y</div>
                </div> */}
                {(data.fileType === 2 || data.fileType === 3) && (
                  <div className="d-flex flex-direction-column justify-content-start pl-2 download-preview">
                    <>
                      <FontAwesomeIcon
                        icon={faDownload}
                        className="mr-top2"
                        style={{ marginRight: "9px" }}
                      />
                      <div
                        onClick={(e) => {
                          previewfile(
                            data.id,
                            data.fileInformationPlanDetails[0].planId
                          );
                        }}
                      >
                        <Link>Download Preview File</Link>
                      </div>
                    </>
                  </div>
                )}
              </div>
            </div>

            {/* <div className="d-flex align-items-center">
              <div className="search-bar-payroll-submission d-flex flex-direction-column">
                <Form
                  onSubmit={(e) => {
                    setRequest({
                      ...request,
                      from:
                        filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
                          ? 0
                          : filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH,
                      searchInput: searchValue,
                    });
                  }}
                >
                  <InputGroup className="width-40-percent">
                    <InputGroup.Prepend>
                      <InputGroup.Text className="plan-search-button">
                        <Image
                          src="/assets/icons/svg/search.svg"
                          width="14px"
                        />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControlSearch
                      type="search"
                      size="1x"
                      placeholder="Search SSN or employee name, Plan ID"
                      onChange={handleSearchChange}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                </Form>
              </div>
              <div className="d-flex flex-row justify-content-space-between align-items-center width-60-percent">
                <div className="align-items-center">
                  <Button
                    className="payroll-search-button"
                    variant="secondary"
                    style={{ marginTop: "auto", marginLeft: "10px" }}
                    onClick={() =>
                      setRequest({
                        ...request,
                        from:
                          filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
                            ? 0
                            : filteredValues?.length -
                              EMPLOYEE_RECORDS_TO_FETCH,
                        searchInput: searchValue,
                      })
                    }
                  >
                    Search
                  </Button>
                </div>
                <div>
                  <p className="ft-14 font-weight-500 black-text m-20">
                    &nbsp; &nbsp; Total Records {totalRecords}
                  </p>
                </div>
              </div>
            </div> */}
            <Tabs
              defaultActiveKey="payroll_details"
              transition={false}
              className="top-level-tab-var mt-3"
              onSelect={setTabIndex}
              activeKey={selectedTabIndex}
              mountOnEnter
              unmountOnExit
            >
              <Tab
                eventKey="payroll_details"
                title={
                  <div className="d-flex onselect-highlight-error">
                    File Details
                  </div>
                }
              >
                <div
                  className="d-flex justify-content-space-between"
                  style={{ color: "#919191" }}
                >
                  {columns?.map((item) => {
                    return <div className={item.className}>{item.label}</div>;
                  })}
                </div>
                <div>
                  <div className="w-100 d-flex justify-content-end">
                    {data?.fileInformationPlanDetails?.length} records found
                  </div>

                  {data?.fileInformationPlanDetails?.map((pending, index) => {
                    return (
                      <>
                        <div
                          onClick={() =>
                            data.fileType != 1 && showPopupAll(pending.id)
                          }
                          className={`d-flex hover-check justify-content-space-between payroll-border ${
                            data.fileType != 1 && "cursor-pointer"
                          }`}
                        >
                          <span className="width-30">
                            {pending.planName.length >= 30 ? (
                              <AddToolTip
                                name={pending.planName}
                                placement="bottom"
                              >
                                {(pending.planName || "").slice(0, 15)}...
                              </AddToolTip>
                            ) : (
                              <span className="width-30">
                                {pending.planName}
                              </span>
                            )}
                          </span>

                          <span className="width-30 ">{pending.planId}</span>
                          <span className="width-30">
                            {moment(formattedPayDate).isValid()
                              ? formattedPayDate
                              : data.payDate}
                          </span>
                          <span className="width-30">{data.totalRecords}</span>
                        </div>
                      </>
                    );
                  })}
                </div>
              </Tab>
              <Tab
                eventKey="employee_details"
                title={
                  <div className="d-flex onselect-highlight-error">
                    Employee Details
                  </div>
                }
              >
                <div
                  className="d-flex mt-3 payroll-submission"
                  style={{ color: "#919191" }}
                >
                  {employeeColumns?.map((item) => {
                    return <div className={item.className}>{item.label}</div>;
                  })}
                </div>
                <div className="file-employee-details-tab-children">
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      setAppend(true);
                      setRequest((request) => {
                        return { ...request, from: filteredValues?.length };
                      });
                    }}
                    hasMore={!stopInfiniteScroll}
                    initialLoad={false}
                    threshold={100}
                    useWindow={false}
                    loader={
                      <div className="loader" key={0}>
                        Loading ...
                      </div>
                    }
                  >
                    <div className="w-100 d-flex justify-content-end">
                      {filteredValues?.length} records found
                    </div>
                    {filteredValues?.map((pending, index) => {
                      return (
                        <>
                          <div
                            onClick={() =>
                              data.fileType != 1 && showPopup(pending.id)
                            }
                            className={`d-flex hover-check justify-content-space-between payroll-border ${
                              data.fileType != 1 && "cursor-pointer"
                            }`}
                          >
                            <span className="d-flex flex-col ft-14 width-40">
                              {pending.employeeName.length >= 30 ? (
                                <AddToolTip
                                  name={pending.employeeName}
                                  placement="bottom"
                                >
                                  <span>
                                    {(pending.employeeName || "").slice(0, 30)}
                                    ...
                                  </span>
                                </AddToolTip>
                              ) : (
                                <span>{pending.employeeName}</span>
                              )}
                              <span>{ssnMasking(pending.ssn)}</span>
                            </span>
                            <span className="width-40">
                              <div className="d-flex flex-column">
                                {pending.planId.length >= 30 ? (
                                  <AddToolTip
                                    name={pending.planId}
                                    placement="bottom"
                                  >
                                    <span>
                                      {(pending.planId || "").slice(0, 30)}
                                      ...
                                    </span>
                                  </AddToolTip>
                                ) : (
                                  <span>{pending.planId}</span>
                                )}
                              </div>
                              <div className="d-flex flex-column">
                                {!isEmpty(data) &&
                                get(
                                  data,
                                  "fileInformationPlanDetails.0.planName"
                                ).length >= 30 ? (
                                  <AddToolTip
                                    name={get(
                                      data,
                                      "fileInformationPlanDetails.0.planName"
                                    )}
                                    placement="bottom"
                                  >
                                    <span>
                                      {(
                                        get(
                                          data,
                                          "fileInformationPlanDetails.0.planName"
                                        ) || ""
                                      ).slice(0, 30)}
                                      ...
                                    </span>
                                  </AddToolTip>
                                ) : (
                                  <span>
                                    {!isEmpty(data) &&
                                      get(
                                        data,
                                        "fileInformationPlanDetails.0.planName"
                                      )}
                                  </span>
                                )}
                              </div>
                            </span>
                            <span className="width-20">
                              {usDateFormat(pending.payDate)}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </InfiniteScroll>
                </div>
              </Tab>
            </Tabs>
          </Col>
          {/* <Col md="4">
            <div className="pl-4">
              <h4 className="total-text">Total Funding</h4>
              <h1 className="total-amount">{usCurrency(data.totalAmount)}</h1>
              {enableView.current ? (
                <Link className="ft-14" onClick={showPopupAll}>
                  View payroll details
                </Link>
              ) : null}
              {enableSubmit &&
              permissions[roleName]["payrollSubMenu"][
                camelCase(subMenu)
              ].includes("U") ? (
              <Button variant="primary" onClick={finalSubmitClick}>
                Submit Payroll
              </Button>
              ) : null}
            </div>
          </Col> */}
        </Row>
        <SliderPanel
          isOpen={isModalOpen}
          size="38"
          showCancel={false}
          backdropClicked={() => setModalOpen(false)}
          showBackButton={false}
        >
          <div className="pb-3 mt-3 d-flex align-items-center justify-content-between">
            <div className="payroll-header mt-3">Employee Reports</div>
            <div
              className="d-flex flex-row mt-2"
              onClick={() => setModalOpen(false)}
            >
              {/* <div>
                <FontAwesomeIcon
                  icon={faTimes}
                  size="md"
                  //   onClick={() => setModalOpen(false)}
                  className="pointer mt-1 primary-small"
                />
              </div> */}
              <Button className="payroll-close ml-2 pointer">Close</Button>
            </div>
          </div>
          <PayrollPendingSubmission
            data={selectedList}
            fileId={fileId}
            hideField={false}
          />
        </SliderPanel>
        <SliderPanel
          isOpen={isModalOpenAll}
          size="38"
          showCancel={false}
          showBackButton={false}
          backdropClicked={() => setModalOpenAll(false)}
        >
          <div className="pb-3 mt-3 d-flex align-items-center justify-content-between">
            <div className="payroll-header mt-3">Payroll Details</div>
            <div
              className="d-flex flex-row mt-2"
              onClick={() => setModalOpenAll(false)}
            >
              {/* <div>
                <FontAwesomeIcon
                  icon={faTimes}
                  size="md"
                  color="$primary"
                  //  onClick={() => setModalOpenAll(false)}
                  className="pointer mt-1"
                />
              </div> */}
              <Button className="payroll-close ml-2 pointer">Close</Button>
            </div>
          </div>
          <PayrollPendingSubmission fileId={fileId} hideField={true} />
        </SliderPanel>
        <Modal show={isWarningModalOpen} onHide={handleClose}>
          <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
            <div className="text-right">
              <FontAwesomeIcon
                icon={faTimes}
                color="#000"
                onClick={handleClose}
              />
            </div>
            <div className="d-flex">
              <div className="pd-15">
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  color="#f94f50"
                  size="3x"
                />
              </div>
              <div className="remove-text">
                {notification.map((x) => (
                  <p>{x.messageDescCode} </p>
                ))}

                <br />
                <Button
                  className="remove-btn mr-4"
                  onClick={AcceptNotificationClick}
                >
                  Ok
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </LoaderWrapper>
  );
};

export default PayrollSubmission;
